import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as typeMessages from '../../store/typeMessages'
import { Row, Col, Card } from 'antd'

import Gauge from '../../charts/Gauge'
import LinearChartLive from '../../charts/LinearChartLive'
import { LoadingChart } from '../../utils/Utils'

class Pressure extends Component {
  render () {
    let cfpressure = this.props.cfpressure
    let pressure = this.props.pressure
    return (
      <Row type='flex' justify='center' gutter={8} style={{ padding: '10px' }}>
        <Col md={20} xs={24} align='center' >
          <Card bodyStyle={{ padding: '0' }} style={{ marginBottom: '10px' }}>
            {cfpressure.populated
              ? <LinearChartLive
                min={340}
                max={390}
                unit='PSI'
                height={320}
                title={`CF PRESSURE ${this.props.title}`}
                data={cfpressure.data}
                lastValue={[cfpressure.lastUpdate, cfpressure.lastValue]}
                color='#faad14'
                ylabel='Pounds per square inch'
                type='spline'
              />
              : <LoadingChart height={320} />
            }
          </Card>
        </Col>
        <Col md={4} xs={24} align='center' >
          <Card bodyStyle={{ padding: '0' }} style={{ marginBottom: '10px' }}>
            <Gauge
              unit='PSI'
              width={140}
              stops={[
                [140, '#a0d911'],
                [150, '#faad14'],
                [155, '#f5222d']
              ]}
              min={0}
              max={160}
              data={cfpressure.lastValue}
              title={`CF PRESSURE`}
            />
          </Card>
        </Col>
        <Col md={20} xs={24} align='center' >
          <Card bodyStyle={{ padding: '0' }} style={{ marginBottom: '10px' }}>
            {pressure.populated
              ? <LinearChartLive
                min={340}
                max={390}
                unit='PSI'
                height={320}
                title={`PRESSURE ${this.props.title}`}
                data={pressure.data}
                lastValue={[pressure.lastUpdate, pressure.lastValue]}
                color='#ffd591'
                ylabel='Pounds per square inch'
                type='spline'
              />
              : <LoadingChart height={320} />
            }
          </Card>
        </Col>
        <Col md={4} xs={24} align='center' >
          <Card bodyStyle={{ padding: '0' }} style={{ marginBottom: '10px' }}>
            <Gauge
              unit='PSI'
              width={140}
              stops={[
                [140, '#a0d911'],
                [150, '#faad14'],
                [155, '#f5222d']
              ]}
              min={0}
              max={160}
              data={pressure.lastValue}
              title={`PRESSURE`}
            />
          </Card>
        </Col>
      </Row>
    )
  }
}

Pressure.propTypes = {
  title: PropTypes.string,
  cfpressure: PropTypes.shape({
    lastValue: PropTypes.number,
    lastUpdate: PropTypes.number,
    data: PropTypes.array,
    ready: PropTypes.bool
  }),
  pressure: PropTypes.shape({
    lastValue: PropTypes.number,
    lastUpdate: PropTypes.number,
    data: PropTypes.array,
    ready: PropTypes.bool
  })
}

function mapStateToProps (state) {
  let { valledetenza } = state.locations
  return {
    title: `VALLE DE TENZA`,
    cfpressure: valledetenza.indicators.cfpressure,
    pressure: valledetenza.indicators.pressure
  }
}
function mapDispatchToProps (dispatch) {
  return bindActionCreators(typeMessages, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Pressure)



// WEBPACK FOOTER //
// ./src/boards/valleDeTenza/Pressure.js